import { skeletonize } from "../../helpers/skeletonize";
import {
  ChipSkeleton as ChipSkeletonBase,
  Props,
  Text,
} from "./StatusChip.Parts";
import { InactiveIcon } from "./icons/inactive/Inactive";

const ChipSkeleton = skeletonize(ChipSkeletonBase);

export const StatusChipSkeleton = ({ label, variant }: Props) => {
  return (
    <ChipSkeleton $variant={variant}>
      <InactiveIcon />
      <Text>{label}</Text>
    </ChipSkeleton>
  );
};
